var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo, useState, useEffect } from "react";
import EquitySearchBlock from "./EquitySearchBlock";
import GenericDropdownTabs from "./Generic/GenericDropdownTabs";
import AllSearchDataBlock from "./AllSearchDataBlock";
import searchDi from "@mainDi/features/Search/servicelocator";
import { activeSectionOptions, SearchAssetTypeEnum, SearchAssetTypeNameEnum, searchFilters, } from "./constant";
import { getRecentSearchList } from "./RecentSearch";
import Errormsg from "@frameworks/web/components/generic/errorMsg";
import EdModal from "@frameworks/web/components/generic/edModal";
import { Col, Row, Spinner } from "react-bootstrap";
import Checkbox from "@frameworks/web/components/generic/CheckBoxGeneric";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import { EExchangeType } from "@domains/features/Markets/Equity/entities/iTopGainersLosers";
import "../../stylesheets/components/Search/AllSearch.scss";
import _ from "underscore";
import { useInView } from "react-intersection-observer";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/web/components/generic/error";
import { getSearchStreamUpdate } from "@domains/features/Search/utils/SearchUtils";
import { getAllExpiryList } from "@domains/features/Markets/Options/mapper/bseNseExpiryMapper";
import { useCustomSelector } from "@frameworks/shared-library/components/customHooks/customUseSector";
import { accountDetails } from "@mainDi/salesDi";
var ExchangeSelect = [
    { value: EExchangeType.NSE, display: "NSE" },
    { value: EExchangeType.BSE, display: "BSE" },
];
export var getSearchEnum = function (activeTab, getType) {
    var active;
    Object.entries(SearchAssetTypeNameEnum).map(function (_a) {
        var _b = __read(_a, 2), nameKey = _b[0], values = _b[1];
        if (activeTab === values)
            active = nameKey;
    });
    if (getType)
        Object.entries(SearchAssetTypeEnum).map(function (_a) {
            var _b = __read(_a, 2), nameKey = _b[0], values = _b[1];
            if (nameKey === active)
                active = values;
        });
    return active;
};
var SearchTabs = function (props) {
    var _a;
    var _b, _c, _d, _e, _f;
    var device = DeviceContext();
    var _g = __read(useState(""), 2), accountCode = _g[0], setAccountCode = _g[1];
    // const {
    //   data: indexList,
    //   loader,
    //   errorData,
    // } = useSelector(
    //   (state: RootState) => state.postLogin.IndexDetails,
    //   _.isEqual
    // );
    var accountCodeFromRedux = useCustomSelector(function (state) { return state.accountDetailsReducer.accountCode; }, _.isEqual);
    var guestUserID = useCustomSelector(function (state) { return state.LoginFlow.guestValidateMPIN.data.guestId; }, _.isEqual);
    var futureDateList = useCustomSelector(function (state) { return state.markets.options.bseNseExpiry.data; }, _.isEqual);
    var _h = __read(React.useState(false), 2), click = _h[0], setClick = _h[1];
    var _j = __read(useState(), 2), trending = _j[0], setTrending = _j[1];
    var _k = __read(useState((_a = {},
        _a[SearchAssetTypeEnum.ComFut] = [],
        _a[SearchAssetTypeEnum.ComOpt] = [],
        _a[SearchAssetTypeEnum.CurFut] = [],
        _a[SearchAssetTypeEnum.CurOpt] = [],
        _a[SearchAssetTypeEnum.ETFs] = [],
        _a[SearchAssetTypeEnum.Equity] = [],
        _a[SearchAssetTypeEnum.Future] = [],
        _a[SearchAssetTypeEnum.Indices] = [],
        _a[SearchAssetTypeEnum.MF] = [],
        _a[SearchAssetTypeEnum.NcdSecondary] = [],
        _a[SearchAssetTypeEnum.Option] = [],
        _a[SearchAssetTypeEnum.PrimaryMarket] = [],
        _a)), 2), assetTrending = _k[0], setAssetTrending = _k[1];
    var _l = __read(useState({ isOpen: false, error: null }), 2), error = _l[0], setError = _l[1];
    var _m = __read(useState(), 2), recentSearch = _m[0], setRecentSearch = _m[1];
    var _o = __read(useState(searchFilters), 2), filters = _o[0], setFilters = _o[1];
    var _p = __read(useState(), 2), defaultExchange = _p[0], setDefaultExchange = _p[1];
    var _q = __read(React.useState([]), 2), inViewData = _q[0], setInviewData = _q[1];
    var _r = __read(React.useState(undefined), 2), initStream = _r[0], setInitStream = _r[1];
    var _s = __read(useState([]), 2), expiryDates = _s[0], setExpiryDates = _s[1];
    var _t = __read(useState([]), 2), selectedExpiry = _t[0], setSelectedExpiry = _t[1];
    var _u = __read(React.useState([]), 2), symbols = _u[0], setSymbols = _u[1];
    var _v = __read(useState([]), 2), storedRecent = _v[0], setStoredRecent = _v[1];
    var _w = useInView(activeSectionOptions), ref = _w.ref, inView = _w.inView;
    // const checkLoggedIn = useMemo(
    //   () => !!userID && userType === ILoginFlows.CLIENT,
    //   [userID, userType]
    // );
    // let checkUserData = async () => {
    //   if (!!userId) {
    //     setUserType(ILoginFlows.CLIENT);
    //     setUserID(userId);
    //   }
    //   if (!!guestUserID) {
    //     setUserType(ILoginFlows.GUEST);
    //     setUserID(guestUserID);
    //   }
    // };
    // useEffect(() => {
    //   checkUserData();
    // }, [userId, guestUserID]);
    // useEffect(() => {
    //   if (checkLoggedIn) {
    //     if (!!indexList?.defExc) {
    //       defaultExchangeApply(indexList?.defExc as EExchangeType, false);
    //     }
    //   }
    // }, [userID, userType]);
    var getData = function () {
        if (accountCode) {
            if (!!!props.searchData) {
                props.setLoader(true);
                setError({ isOpen: false, error: null });
                var genTrending = searchDi.search.getTrending({
                    accountId: accountCode,
                });
                Promise.all([genTrending])
                    .then(function (data) {
                    var _a;
                    setTrending(data[0].trending);
                    setRecentSearch((_a = data[0].recent) === null || _a === void 0 ? void 0 : _a.filter(function (x) { return x !== null; }));
                })
                    .catch(function (error) {
                    setError({ isOpen: true, error: error });
                })
                    .finally(function () { return setTimeout(function () { return props.setLoader(false); }, 100); });
            }
        }
        else {
            getRecentSearchList("allRecentSearch").then(function (data) {
                var request = "";
                setStoredRecent(data);
                data === null || data === void 0 ? void 0 : data.map(function (recent, i) {
                    if (i < 15) {
                        request = request.concat("".concat(recent.symbol, ","));
                    }
                });
                if (!!!props.searchData) {
                    props.setLoader(true);
                    var genTrending = searchDi.search.getTrending({
                        recentSymbols: request.slice(0, -1),
                        accountId: accountCode,
                    });
                    // const trendingData = searchDi.search.allAssetTrending();
                    setError({ isOpen: false, error: null });
                    Promise.all([genTrending])
                        .then(function (data) {
                        var _a, _b, _c;
                        setTrending((_a = data[0]) === null || _a === void 0 ? void 0 : _a.trending);
                        setRecentSearch((_c = (_b = data[0]) === null || _b === void 0 ? void 0 : _b.recent) === null || _c === void 0 ? void 0 : _c.filter(function (x) { return x !== null; }));
                        // setAssetTrending(data[0]);
                    })
                        .catch(function (error) {
                        setError({ isOpen: true, error: error });
                    })
                        .finally(function () { return setTimeout(function () { return props.setLoader(false); }, 100); });
                }
                // getRecentSearchList().then((z) => setRecentSearch(z));
            });
        }
    };
    useEffect(function () {
        if (accountCodeFromRedux) {
            setAccountCode(accountCodeFromRedux);
        }
        else {
            accountDetails
                .getSalesEmployeeCode()
                .then(function (data) {
                setAccountCode(data);
            })
                .catch(function (error) {
                console.log(error);
            });
        }
    }, [accountCodeFromRedux]);
    useEffect(function () {
        if (!(props === null || props === void 0 ? void 0 : props.cachingAtMiddleWare)) {
            if (!props.openOption)
                getData();
        }
    }, [props.openOption, accountCode]);
    // useEffect(() => {
    //   if (checkLoggedIn) postLoginDi.postLogin.getIndexDetails();
    // }, [checkLoggedIn]);
    var searchTabArray = useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        var tabData = [
            {
                title: "All",
                eventKey: "All",
                value: "All",
                filters: false,
                tabContent: (React.createElement(AllSearchDataBlock, { data: props.searchData, trending: trending, assetTrending: assetTrending, recentSearch: recentSearch, closePopup: function () { return props.serachPopup(false); }, setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setRecentSearch: setRecentSearch, inViewCallBack: {
                        key: "symbol",
                        callback: function (list) {
                            setSymbols(function (oldSymbol) {
                                if (oldSymbol.length > 0)
                                    callStream(false);
                                return oldSymbol;
                            });
                            setSymbols(JSON.parse(JSON.stringify(list)));
                        },
                    }, setInviewData: setInviewData, inViewData: inViewData, setSearchedQuote: props.setSearchedQuote, placeOrder: props.placeOrder, cachingAtMiddleWare: props === null || props === void 0 ? void 0 : props.cachingAtMiddleWare })),
            },
            {
                title: "EQ",
                eventKey: "EQ",
                filters: false,
                value: SearchAssetTypeEnum.Equity,
                tabContent: (React.createElement(EquitySearchBlock, { setSearchedQuote: props.setSearchedQuote, inViewCallBack: {
                        key: "symbol",
                        callback: function (list) {
                            setSymbols(function (oldSymbol) {
                                if (oldSymbol.length > 0)
                                    callStream(false);
                                return oldSymbol;
                            });
                            setSymbols(JSON.parse(JSON.stringify(list)));
                        },
                    }, setInviewData: setInviewData, inViewData: inViewData, data: (_a = props.searchData) === null || _a === void 0 ? void 0 : _a.find(function (x) { return x.assetType === SearchAssetTypeEnum.Equity; }), trending: !!assetTrending && assetTrending[SearchAssetTypeEnum.Equity], search: props.search, recentType: SearchAssetTypeEnum.Equity, type: SearchAssetTypeEnum.Equity, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter(function (x) { return (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.Equity; }), filters: filters.find(function (x) { return x.filterName === SearchAssetTypeEnum.Equity; }), closePopup: function () { return props.serachPopup(false); }, setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setRecentSearch: setRecentSearch, setSearchData: props.setSearchData, placeOrder: props.placeOrder })),
            },
            {
                title: "FUT",
                eventKey: "FUT",
                filters: false,
                value: SearchAssetTypeEnum.Future,
                tabContent: (React.createElement(EquitySearchBlock, { setSearchedQuote: props.setSearchedQuote, inViewCallBack: {
                        key: "symbol",
                        callback: function (list) {
                            setSymbols(function (oldSymbol) {
                                if (oldSymbol.length > 0)
                                    callStream(false);
                                return oldSymbol;
                            });
                            setSymbols(JSON.parse(JSON.stringify(list)));
                        },
                    }, setInviewData: setInviewData, inViewData: inViewData, data: (_b = props.searchData) === null || _b === void 0 ? void 0 : _b.find(function (x) { return x.assetType === SearchAssetTypeEnum.Future; }), trending: !!assetTrending && assetTrending[SearchAssetTypeEnum.Future], search: props.search, recentType: SearchAssetTypeEnum.Future, type: SearchAssetTypeEnum.Future, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter(function (x) { return (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.Future; }), closePopup: function () { return props.serachPopup(false); }, setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setRecentSearch: setRecentSearch, setSearchData: props.setSearchData, placeOrder: props.placeOrder })),
            },
            {
                title: "OPT",
                eventKey: "OPT",
                value: SearchAssetTypeEnum.Option,
                filters: false,
                tabContent: (React.createElement(EquitySearchBlock, { setSearchedQuote: props.setSearchedQuote, inViewCallBack: {
                        key: "symbol",
                        callback: function (list) {
                            setSymbols(function (oldSymbol) {
                                if (oldSymbol.length > 0)
                                    callStream(false);
                                return oldSymbol;
                            });
                            setSymbols(JSON.parse(JSON.stringify(list)));
                        },
                    }, setInviewData: setInviewData, inViewData: inViewData, data: (_c = props.searchData) === null || _c === void 0 ? void 0 : _c.find(function (x) { return x.assetType === SearchAssetTypeEnum.Option; }), trending: !!assetTrending && assetTrending[SearchAssetTypeEnum.Option], search: props.search, recentType: SearchAssetTypeEnum.Option, type: SearchAssetTypeEnum.Option, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter(function (x) { return (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.Option; }), selectedOption: props.selectedOption, closePopup: function () { return props.serachPopup(false); }, setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setRecentSearch: setRecentSearch, expiryDates: expiryDates, setExpiryDates: setExpiryDates, selectedExpiry: selectedExpiry, setSelectedExpiry: setSelectedExpiry, setSearchData: props.setSearchData, placeOrder: props.placeOrder })),
            },
            {
                title: "MF",
                eventKey: "MF",
                value: SearchAssetTypeEnum.MF,
                filters: false,
                tabContent: (React.createElement(EquitySearchBlock, { setSearchedQuote: props.setSearchedQuote, setInviewData: setInviewData, inViewData: inViewData, data: (_d = props.searchData) === null || _d === void 0 ? void 0 : _d.find(function (x) { return x.assetType === SearchAssetTypeEnum.MF; }), trending: !!assetTrending && assetTrending[SearchAssetTypeEnum.MF], search: props.search, recentType: SearchAssetTypeEnum.MF.toUpperCase(), type: SearchAssetTypeEnum.MF, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter(function (x) { return (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.MF; }), filters: filters.find(function (x) { return x.filterName === SearchAssetTypeEnum.MF; }), closePopup: function () { return props.serachPopup(false); }, setRecentSearch: setRecentSearch, setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setSearchData: props.setSearchData, placeOrder: props.placeOrder })),
            },
            {
                title: "CURFUT",
                eventKey: "CURFUT",
                value: SearchAssetTypeEnum.CurFut,
                tabContent: (React.createElement(EquitySearchBlock, { setSearchedQuote: props.setSearchedQuote, inViewCallBack: {
                        key: "symbol",
                        callback: function (list) {
                            setSymbols(function (oldSymbol) {
                                if (oldSymbol.length > 0)
                                    callStream(false);
                                return oldSymbol;
                            });
                            setSymbols(JSON.parse(JSON.stringify(list)));
                        },
                    }, setInviewData: setInviewData, inViewData: inViewData, data: (_e = props.searchData) === null || _e === void 0 ? void 0 : _e.find(function (x) { return x.assetType === SearchAssetTypeEnum.CurFut; }), trending: !!assetTrending && assetTrending[SearchAssetTypeEnum.CurFut], search: props.search, recentType: SearchAssetTypeEnum.CurFut, type: SearchAssetTypeEnum.CurFut, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter(function (x) { return (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.CurFut; }), filters: filters.find(function (x) { return x.filterName === SearchAssetTypeEnum.CurFut; }), closePopup: function () { return props.serachPopup(false); }, setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setRecentSearch: setRecentSearch, setSearchData: props.setSearchData, placeOrder: props.placeOrder })),
            },
            {
                title: "CUROPT",
                eventKey: "CUROPT",
                value: SearchAssetTypeEnum.CurOpt,
                tabContent: (React.createElement(EquitySearchBlock, { setSearchedQuote: props.setSearchedQuote, inViewCallBack: {
                        key: "symbol",
                        callback: function (list) {
                            setSymbols(function (oldSymbol) {
                                if (oldSymbol.length > 0)
                                    callStream(false);
                                return oldSymbol;
                            });
                            setSymbols(JSON.parse(JSON.stringify(list)));
                        },
                    }, setInviewData: setInviewData, inViewData: inViewData, data: (_f = props.searchData) === null || _f === void 0 ? void 0 : _f.find(function (x) { return x.assetType === SearchAssetTypeEnum.CurOpt; }), trending: !!assetTrending && assetTrending[SearchAssetTypeEnum.CurOpt], search: props.search, recentType: SearchAssetTypeEnum.CurOpt, type: SearchAssetTypeEnum.CurOpt, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter(function (x) { return (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.CurOpt; }), filters: filters.find(function (x) { return x.filterName === SearchAssetTypeEnum.CurOpt; }), closePopup: function () { return props.serachPopup(false); }, setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setRecentSearch: setRecentSearch, setExpiryDates: setExpiryDates, selectedOption: props === null || props === void 0 ? void 0 : props.selectedOption, setSearchData: props.setSearchData, expiryDates: expiryDates, selectedExpiry: selectedExpiry, setSelectedExpiry: setSelectedExpiry, placeOrder: props.placeOrder })),
            },
            // {
            //   title: "COM",
            //   eventKey: "COM",
            //   value: SearchAssetTypeEnum.Commodity,
            //   filters: false,
            //   tabContent: (
            //     <EquitySearchBlock
            //       data={
            //         props.searchData?.find(
            //           (x) => x.assetType === SearchAssetTypeEnum.Commodity
            //         )
            //       }
            //       trending={
            //         !!assetTrending && assetTrending[SearchAssetTypeEnum.Commodity]
            //       }
            //       search={props.search}
            //       recentType={SearchAssetTypeEnum.Commodity.toUpperCase()}
            //       type={SearchAssetTypeEnum.Commodity}
            //       recentSearch={recentSearch}
            //     />
            //   ),
            // },
            {
                title: "COMFUT",
                eventKey: "COMFUT",
                value: SearchAssetTypeEnum.ComFut,
                filters: false,
                tabContent: (React.createElement(EquitySearchBlock, { setSearchedQuote: props.setSearchedQuote, inViewCallBack: {
                        key: "symbol",
                        callback: function (list) {
                            setSymbols(function (oldSymbol) {
                                if (oldSymbol.length > 0)
                                    callStream(false);
                                return oldSymbol;
                            });
                            setSymbols(JSON.parse(JSON.stringify(list)));
                        },
                    }, setInviewData: setInviewData, inViewData: inViewData, data: (_g = props.searchData) === null || _g === void 0 ? void 0 : _g.find(function (x) { return x.assetType === SearchAssetTypeEnum.ComFut; }), trending: !!assetTrending && assetTrending[SearchAssetTypeEnum.ComFut], search: props.search, recentType: SearchAssetTypeEnum.ComFut.toUpperCase(), type: SearchAssetTypeEnum.ComFut, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter(function (x) { return (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.ComFut; }), filters: filters.find(function (x) { return x.filterName === SearchAssetTypeEnum.ComFut; }), closePopup: function () { return props.serachPopup(false); }, setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setRecentSearch: setRecentSearch, setSearchData: props.setSearchData, placeOrder: props.placeOrder })),
            },
            {
                title: "COMOPT",
                eventKey: "COMOPT",
                value: SearchAssetTypeEnum.ComOpt,
                filters: false,
                tabContent: (React.createElement(EquitySearchBlock, { setSearchedQuote: props.setSearchedQuote, inViewCallBack: {
                        key: "symbol",
                        callback: function (list) {
                            setSymbols(function (oldSymbol) {
                                if (oldSymbol.length > 0)
                                    callStream(false);
                                return oldSymbol;
                            });
                            setSymbols(JSON.parse(JSON.stringify(list)));
                        },
                    }, setInviewData: setInviewData, inViewData: inViewData, data: (_h = props.searchData) === null || _h === void 0 ? void 0 : _h.find(function (x) { return x.assetType === SearchAssetTypeEnum.ComOpt; }), trending: !!assetTrending && assetTrending[SearchAssetTypeEnum.ComOpt], search: props.search, recentType: SearchAssetTypeEnum.ComOpt.toUpperCase(), type: SearchAssetTypeEnum.ComOpt, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter(function (x) { return (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.ComOpt; }), filters: filters.find(function (x) { return x.filterName === SearchAssetTypeEnum.ComOpt; }), closePopup: function () { return props.serachPopup(false); }, setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setRecentSearch: setRecentSearch, setExpiryDates: setExpiryDates, selectedOption: props.selectedOption, expiryDates: expiryDates, selectedExpiry: selectedExpiry, setSelectedExpiry: setSelectedExpiry, setSearchData: props.setSearchData, placeOrder: props.placeOrder })),
            },
            {
                title: "PRIMARY MRK",
                eventKey: "PRIMARY MRK",
                value: SearchAssetTypeEnum.PrimaryMarket,
                tabContent: (React.createElement(EquitySearchBlock, { setSearchedQuote: props.setSearchedQuote, setInviewData: setInviewData, inViewData: inViewData, data: (_j = props.searchData) === null || _j === void 0 ? void 0 : _j.find(function (x) { return x.assetType === SearchAssetTypeEnum.PrimaryMarket; }), trending: !!assetTrending &&
                        assetTrending[SearchAssetTypeEnum.PrimaryMarket], search: props.search, recentType: SearchAssetTypeEnum.PrimaryMarket, type: SearchAssetTypeEnum.PrimaryMarket, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter(function (x) { return (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.PrimaryMarket; }), filters: filters.find(function (x) { return x.filterName === SearchAssetTypeEnum.PrimaryMarket; }), closePopup: function () { return props.serachPopup(false); }, setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setRecentSearch: setRecentSearch, setSearchData: props.setSearchData, placeOrder: props.placeOrder })),
            },
            {
                title: "ETF",
                eventKey: "ETF",
                value: SearchAssetTypeEnum.ETFs,
                filters: false,
                tabContent: (React.createElement(EquitySearchBlock, { setSearchedQuote: props.setSearchedQuote, inViewCallBack: {
                        key: "quoteSymbol",
                        callback: function (list) {
                            setSymbols(function (oldSymbol) {
                                if (oldSymbol.length > 0)
                                    callStream(false);
                                return oldSymbol;
                            });
                            setSymbols(JSON.parse(JSON.stringify(list)));
                        },
                    }, setInviewData: setInviewData, inViewData: inViewData, data: (_k = props.searchData) === null || _k === void 0 ? void 0 : _k.find(function (x) { return x.assetType === SearchAssetTypeEnum.ETFs; }), trending: !!assetTrending && assetTrending[SearchAssetTypeEnum.ETFs], search: props.search, recentType: SearchAssetTypeEnum.ETFs, type: SearchAssetTypeEnum.ETFs, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter(function (x) { return (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.ETFs; }), closePopup: function () { return props.serachPopup(false); }, setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setRecentSearch: setRecentSearch, setSearchData: props.setSearchData, placeOrder: props.placeOrder })),
            },
            {
                title: "NCD",
                eventKey: "NCD",
                value: SearchAssetTypeEnum.NcdSecondary,
                filters: false,
                tabContent: (React.createElement(EquitySearchBlock, { setSearchedQuote: props.setSearchedQuote, inViewCallBack: {
                        key: "ncdSymbol",
                        callback: function (list) {
                            setSymbols(function (oldSymbol) {
                                if (oldSymbol.length > 0)
                                    callStream(false);
                                return oldSymbol;
                            });
                            setSymbols(JSON.parse(JSON.stringify(list)));
                        },
                    }, setInviewData: setInviewData, inViewData: inViewData, data: (_l = props.searchData) === null || _l === void 0 ? void 0 : _l.find(function (x) { return x.assetType === SearchAssetTypeEnum.NcdSecondary; }), trending: !!assetTrending && assetTrending[SearchAssetTypeEnum.NcdSecondary], search: props.search, recentType: SearchAssetTypeEnum.NcdSecondary, type: SearchAssetTypeEnum.NcdSecondary, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter(function (x) { return (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.NcdSecondary; }), closePopup: function () { return props.serachPopup(false); }, setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setRecentSearch: setRecentSearch, setSearchData: props.setSearchData, placeOrder: props.placeOrder })),
            },
            {
                title: "INDICES",
                eventKey: "INDICES",
                value: SearchAssetTypeEnum.Indices,
                filters: false,
                tabContent: (React.createElement(EquitySearchBlock, { setSearchedQuote: props.setSearchedQuote, inViewCallBack: {
                        key: "symbol",
                        callback: function (list) {
                            setSymbols(function (oldSymbol) {
                                if (oldSymbol.length > 0)
                                    callStream(false);
                                return oldSymbol;
                            });
                            setSymbols(JSON.parse(JSON.stringify(list)));
                        },
                    }, setInviewData: setInviewData, inViewData: inViewData, data: (_m = props.searchData) === null || _m === void 0 ? void 0 : _m.find(function (x) { return x.assetType === SearchAssetTypeEnum.Indices; }), trending: !!assetTrending && assetTrending[SearchAssetTypeEnum.Indices], search: props.search, recentType: SearchAssetTypeEnum.Indices, type: SearchAssetTypeEnum.Indices, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter(function (x) { return (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.Indices; }), closePopup: function () { return props.serachPopup(false); }, setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setRecentSearch: setRecentSearch, setSearchData: props.setSearchData, placeOrder: props.placeOrder })),
            },
            // {
            //   title: "SGB",
            //   eventKey: "SGB",
            //   value: SearchAssetTypeEnum.SGB,
            //   filters: false,
            //   tabContent: (
            //     <EquitySearchBlock
            //       data={
            //         props.searchData?.find(
            //           (x) => x.assetType === SearchAssetTypeEnum.SGB
            //         )
            //       }
            //       trending={!!assetTrending && assetTrending[SearchAssetTypeEnum.SGB]}
            //       search={props.search}
            //       recentType={SearchAssetTypeEnum.SGB.toUpperCase()}
            //       type={SearchAssetTypeEnum.SGB}
            //       recentSearch={recentSearch?.filter(
            //         (x) => x?.assetType === SearchAssetTypeEnum.SGB
            //       )}
            //       closePopup={() => props.serachPopup(false)}
            //     />
            //   ),
            // },
            // {
            //   title: "CORP FD",
            //   eventKey: "CORP FD",
            //   value: SearchAssetTypeEnum.CORPFD,
            //   filters: false,
            //   tabContent: (
            //     <EquitySearchBlock
            //       data={
            //         props.searchData?.find(
            //           (x) => x.assetType === SearchAssetTypeEnum.CORPFD
            //         )
            //       }
            //       trending={
            //         !!assetTrending && assetTrending[SearchAssetTypeEnum.CORPFD]
            //       }
            //       search={props.search}
            //       recentType={SearchAssetTypeEnum.CORPFD.toUpperCase()}
            //       type={SearchAssetTypeEnum.CORPFD}
            //       recentSearch={recentSearch?.filter(
            //         (x) => x?.assetType === SearchAssetTypeEnum.CORPFD
            //       )}
            //       closePopup={() => props.serachPopup(false)}
            //     />
            //   ),
            // },
            // {
            //   title: "NFO",
            //   eventKey: "NFO",
            //   value: SearchAssetTypeEnum.NFO,
            //   tabContent: <NfoSearchBlock />,
            // },
            // {
            //   title: "OFS",
            //   eventKey: "OFS",
            //   value: SearchAssetTypeEnum.OFS,
            //   tabContent: <OfsSearchBlock />,
            // },
        ];
        if (props.searchData && ((_o = props.searchData) === null || _o === void 0 ? void 0 : _o.length) > 0) {
            var list = props.searchData
                .map(function (z) {
                var tab = tabData.find(function (x) { return x.value === z.assetType; });
                if (SearchAssetTypeEnum.Equity === z.assetType) {
                    return __assign(__assign({}, tab), { filters: true });
                }
                if (SearchAssetTypeEnum.ComFut === z.assetType) {
                    return __assign(__assign({}, tab), { filters: true });
                }
                if (SearchAssetTypeEnum.ComOpt === z.assetType) {
                    return __assign(__assign({}, tab), { filters: true });
                }
                if (SearchAssetTypeEnum.PrimaryMarket === z.assetType) {
                    return __assign(__assign({}, tab), { filters: true });
                }
                if (SearchAssetTypeEnum.MF === z.assetType) {
                    return __assign(__assign({}, tab), { filters: true });
                }
                return tabData.find(function (x) { return x.value === z.assetType; });
            })
                .filter(function (x) { return x; });
            return list;
        }
        return tabData;
    }, [
        props.searchData,
        trending,
        assetTrending,
        recentSearch,
        JSON.stringify(filters),
        props.selectedOption,
        props.loader,
        expiryDates,
        selectedExpiry,
    ]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        if (props === null || props === void 0 ? void 0 : props.selectedOption) {
            if (((_b = (_a = props === null || props === void 0 ? void 0 : props.selectedOption) === null || _a === void 0 ? void 0 : _a.expiryLst) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                setExpiryDates((_d = (_c = props === null || props === void 0 ? void 0 : props.selectedOption) === null || _c === void 0 ? void 0 : _c.expiryLst) === null || _d === void 0 ? void 0 : _d.map(function (list) {
                    return {
                        display: list,
                        value: list,
                    };
                }));
            }
            else {
                var list = ((_e = props === null || props === void 0 ? void 0 : props.selectedOption) === null || _e === void 0 ? void 0 : _e.exchange) === "BFO"
                    ? futureDateList === null || futureDateList === void 0 ? void 0 : futureDateList.bse
                    : futureDateList === null || futureDateList === void 0 ? void 0 : futureDateList.nse;
                setExpiryDates((_f = getAllExpiryList(list === null || list === void 0 ? void 0 : list.validExpiry, props.selectedOption.instrumentType, props.selectedOption.idx)) === null || _f === void 0 ? void 0 : _f.map(function (x, i) {
                    return {
                        display: x,
                        value: x,
                    };
                }));
            }
        }
    }, [props.selectedOption]);
    useEffect(function () {
        var _a;
        if (searchTabArray.length > 0 &&
            ((_a = props === null || props === void 0 ? void 0 : props.search) === null || _a === void 0 ? void 0 : _a.length) > 2 &&
            props.activeTab === "All")
            props.setActiveTab(searchTabArray[0].eventKey);
    }, [__spreadArray([], __read(searchTabArray === null || searchTabArray === void 0 ? void 0 : searchTabArray.map(function (x) { return x === null || x === void 0 ? void 0 : x.title; })), false), props === null || props === void 0 ? void 0 : props.search]);
    var defaultExchangeApply = function (dExchange, update) {
        // const exchangeFilter = filters.find(
        //   (x) => x.filterName === SearchAssetTypeEnum.Equity
        // );
        // const id = exchangeFilter.list.findIndex((x) => x.key === dExchange);
        // let e: any = {
        //   target: {
        //     checked: true,
        //     type: "checkbox",
        //   },
        // };
        // updateChecked(e, exchangeFilter.filterName, id, setFilters);
        // if (update && checkLoggedIn) {
        //   const payload: IDefaultExchangeRequest = {
        //     exc: defaultExchange,
        //   };
        //   basicProfileDi.basicProfile.defaultExchangeData(payload);
        // }
        // setClick(false);
    };
    useEffect(function () {
        setFilters(JSON.parse(JSON.stringify(searchFilters)));
    }, [props.search]);
    var callStream = function (view) {
        setSymbols(function (sym) {
            searchDi.search.getSearchedStreamData(view, sym, function (mappedData) {
                var _a;
                setRecentSearch(function (prev) { return getSearchStreamUpdate(prev, mappedData); });
                setTrending(function (prev) { return getSearchStreamUpdate(prev, mappedData); });
                if (props.activeTab !== "All" &&
                    (!(props === null || props === void 0 ? void 0 : props.search) || ((_a = props === null || props === void 0 ? void 0 : props.search) === null || _a === void 0 ? void 0 : _a.length) < 3)) {
                    var active_1 = getSearchEnum(props.activeTab);
                    setAssetTrending(function (prev) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[active_1] = getSearchStreamUpdate(prev["".concat(active_1)], mappedData), _a)));
                    });
                }
            });
            return sym;
        });
    };
    useEffect(function () {
        if (inView) {
            setInitStream(true);
        }
        if (!props.loader && !!initStream && (symbols === null || symbols === void 0 ? void 0 : symbols.length) > 0) {
            callStream(inView);
        }
    }, [inView, props.loader, initStream, symbols]);
    useEffect(function () {
        return function () {
            callStream(false);
        };
    }, []);
    useEffect(function () {
        var _a, _b;
        if (props.activeTab !== "All" &&
            (!(props === null || props === void 0 ? void 0 : props.search) || ((_a = props === null || props === void 0 ? void 0 : props.search) === null || _a === void 0 ? void 0 : _a.length) < 3)) {
            setError({ isOpen: false, error: null });
            props.setLoader(true);
            var active_2 = getSearchEnum(props.activeTab);
            var request_1 = "";
            (_b = storedRecent === null || storedRecent === void 0 ? void 0 : storedRecent.filter(function (recent) { return (recent === null || recent === void 0 ? void 0 : recent.assetType) === getSearchEnum(props.activeTab); })) === null || _b === void 0 ? void 0 : _b.map(function (recent, i) {
                if (i < 15) {
                    request_1 = request_1.concat("".concat(recent.symbol, ","));
                }
            });
            var getTrendingPayload_1 = __assign(__assign({ accountId: accountCode }, ((props === null || props === void 0 ? void 0 : props.cachingAtMiddleWare) && {
                trendingAssetType: getSearchEnum(props.activeTab, true),
            })), (!(props === null || props === void 0 ? void 0 : props.cachingAtMiddleWare) && {
                recentSymbols: request_1.slice(0, -1),
            }));
            var fetchTrendingAndRecent = function () { return __awaiter(void 0, void 0, void 0, function () {
                var data_1, error_1;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, 3, 4]);
                            return [4 /*yield*/, searchDi.search.getTrending(getTrendingPayload_1)];
                        case 1:
                            data_1 = _b.sent();
                            setAssetTrending(__assign(__assign({}, assetTrending), (_a = {}, _a[active_2] = data_1.trending, _a)));
                            setRecentSearch(function (prev) {
                                var _a, _b;
                                if (!prev) {
                                    return (_a = data_1 === null || data_1 === void 0 ? void 0 : data_1.recent) === null || _a === void 0 ? void 0 : _a.filter(function (x) { return x !== null; }).slice(0, 5);
                                }
                                var res = prev;
                                var symbols = prev === null || prev === void 0 ? void 0 : prev.map(function (obj) { return obj === null || obj === void 0 ? void 0 : obj.symbol; });
                                (_b = data_1 === null || data_1 === void 0 ? void 0 : data_1.recent) === null || _b === void 0 ? void 0 : _b.map(function (r) {
                                    if ((symbols === null || symbols === void 0 ? void 0 : symbols.indexOf(r === null || r === void 0 ? void 0 : r.symbol)) === -1) {
                                        res === null || res === void 0 ? void 0 : res.push(r);
                                    }
                                });
                                return res;
                            });
                            return [3 /*break*/, 4];
                        case 2:
                            error_1 = _b.sent();
                            setError({ isOpen: true, error: error_1 });
                            return [3 /*break*/, 4];
                        case 3:
                            setTimeout(function () { return props.setLoader(false); }, 100);
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            }); };
            // if cachingAtMiddleWare is true and updatedAccountcode is not empty
            if ((props === null || props === void 0 ? void 0 : props.cachingAtMiddleWare) && accountCode) {
                fetchTrendingAndRecent();
            }
            if (!(props === null || props === void 0 ? void 0 : props.cachingAtMiddleWare)) {
                fetchTrendingAndRecent();
            }
        }
    }, [props.activeTab, props === null || props === void 0 ? void 0 : props.backState, accountCode]);
    return (React.createElement(React.Fragment, null,
        props.loader ? (React.createElement("div", { className: "d-flex align-items-center justify-content-center h-100" },
            React.createElement(Spinner, { animation: "border", role: "status" },
                React.createElement("span", { className: "visually-hidden" }, "Loading...")))) : (React.createElement("div", { className: "search-modal-tabslist" }, props.search && ((_b = props.searchData) === null || _b === void 0 ? void 0 : _b.length) === 0 ? (React.createElement(Errormsg, { icon: "", msg: "No results found", showIcon: false })) : ((_c = props === null || props === void 0 ? void 0 : props.error) === null || _c === void 0 ? void 0 : _c.isOpen) ? (React.createElement(ErrorNotification, { displayType: ErrorDisplayType.INSECTION, error: (_d = props === null || props === void 0 ? void 0 : props.error) === null || _d === void 0 ? void 0 : _d.error, isOpen: (_e = props === null || props === void 0 ? void 0 : props.error) === null || _e === void 0 ? void 0 : _e.isOpen })) : (React.createElement("div", { ref: ref },
            React.createElement(GenericDropdownTabs, { defaultActiveKey: props.activeTab, tabsArray: searchTabArray, filterList: filters, setFilter: setFilters, setOptions: props.setOpt, forceUpdateTab: props.setActiveTab, searchString: ((_f = props === null || props === void 0 ? void 0 : props.search) === null || _f === void 0 ? void 0 : _f.length) > 0, hideTabs: props.hideTabs }))))),
        device && device.isDesktop ? (React.createElement(React.Fragment, null,
            React.createElement(EdModal, { show: click, setShow: setClick, modalTitle: "commonmodal ", title: "Select Default Exchange", size: "commonmodal gray-modal defaultExchange-modal  modal-md modal-dialog-centered", showFooter: false, DisableOutsideClickClose: true, onCloseGoBack: true },
                React.createElement(Row, { className: "mx-0" },
                    React.createElement(Col, { lg: 12 },
                        React.createElement("span", { className: "d-flex DMSans_16_500 txt_blackOne1" }, "Select exchange you\u2019d like to keep default for search results"),
                        React.createElement("span", { className: "d-flex DMSanN_14_400 txt_secondary-gray" }, "This will be applicable across the site. You can always change it in Settings.")),
                    React.createElement(Col, { lg: 4, className: "mgt-20" },
                        React.createElement("div", { className: "grid-2 gap-15" }, ExchangeSelect.map(function (x) {
                            return (React.createElement("div", { className: "common-checkbox" },
                                React.createElement("div", { className: "customFormSection_field checkboxWrap border-box-checkbox" },
                                    React.createElement("div", { className: "checkbox" },
                                        React.createElement("div", { className: "form-check" },
                                            React.createElement(Checkbox, { list: x, name: "placeorder", className: "checkbox common-checkbox-new", onChange: function (e) {
                                                    if (e.target.checked)
                                                        setDefaultExchange(e.target.value);
                                                    else
                                                        setDefaultExchange(undefined);
                                                }, selected: defaultExchange }))))));
                        }))),
                    React.createElement(Col, { lg: 12, className: "mgt-20" },
                        React.createElement(Row, null,
                            React.createElement(Col, { lg: 6, xs: 6, className: "ps-3 d-center-end" },
                                React.createElement(EdButton, { disabled: !!defaultExchange ? false : true, btnTyp: "midnight-blue", value: "Apply", onClick: function () {
                                        return defaultExchangeApply(defaultExchange, true);
                                    } })),
                            React.createElement(Col, { lg: 6, xs: 6, className: "pe-3" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue-border", onClick: function () {
                                        setClick(false);
                                        setDefaultExchange(undefined);
                                    }, value: "Cancel" })))))))) : (React.createElement("div", { className: "mb-genericSidebar" },
            React.createElement(GenericDrawer, { parentClass: "z-index-high", show: click, setShow: setClick, bodyComp: React.createElement(Row, { className: "mx-0" },
                    React.createElement(Col, { lg: 12 },
                        React.createElement("span", { className: "d-flex DMSans_16_500 txt_blackOne1 mgt-20 line-20" }, "Select exchange you\u2019d like to keep default for search results"),
                        React.createElement("span", { className: "d-flex DMSanN_14_400 txt_secondary-gray mgt-5 line-20" }, "This will be applicable across the site. You can always change it in Settings.")),
                    React.createElement(Col, { lg: 4, className: "mgt-20" },
                        React.createElement("div", { className: "grid-4 gap-15" }, ExchangeSelect.map(function (x) {
                            return (React.createElement("div", { className: "common-checkbox" },
                                React.createElement("div", { className: "customFormSection_field checkboxWrap border-box-checkbox" },
                                    React.createElement("div", { className: "checkbox" },
                                        React.createElement("div", { className: "form-check" },
                                            React.createElement(Checkbox, { list: x, name: "placeorder", className: "checkbox common-checkbox-new", onChange: function (e) {
                                                    if (e.target.checked)
                                                        setDefaultExchange(e.target.value);
                                                    else
                                                        setDefaultExchange(undefined);
                                                }, selected: defaultExchange }))))));
                        }))),
                    React.createElement(Col, { lg: 12, className: "mgt-20" },
                        React.createElement(Row, null,
                            React.createElement(Col, { lg: 6, xs: 6, className: "ps-3 d-center-end" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Cancel", className: "w-100", onClick: function () {
                                        setClick(false);
                                        setDefaultExchange(undefined);
                                    } })),
                            React.createElement(Col, { lg: 6, xs: 6, className: "pe-3" },
                                React.createElement(EdButton, { disabled: !!defaultExchange ? false : true, btnTyp: "midnight-blue", value: "Apply", className: "w-100", onClick: function () {
                                        return defaultExchangeApply(defaultExchange, true);
                                    } }))))), headerComp: React.createElement("div", { className: "DMSan_16_700 txt_blackOne1 p-3" }, "Select Default Exchange") })))));
};
export default SearchTabs;
